import { render } from "./ColorDropdownItem.vue?vue&type=template&id=22f179a2&scoped=true"
import script from "./ColorDropdownItem.vue?vue&type=script&lang=js"
export * from "./ColorDropdownItem.vue?vue&type=script&lang=js"

import "./ColorDropdownItem.vue?vue&type=style&index=0&id=22f179a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22f179a2"

export default script